import { PenSquareIcon, Trash2Icon } from 'lucide-react'
import { useState } from 'react'

import { Button, DropdownMenu, IconButton } from 'slab'

import CardPaymentDetails from '../payments/CardPaymentDetails'
import CardPaymentModal from '../payments/CardPaymentModal'

type CardDetails = {
  brand: string;
  last4: string;
}

type Props = {
  cardDetails?: CardDetails;
  readonly?: boolean;
  onRemovePaymentMethod?: () => void;
}

export default function PaymentDetails ({ cardDetails, readonly, onRemovePaymentMethod }: Props) {
  const [isCardPaymentModalOpen, setIsCardPaymentModalOpen] = useState(false)

  const showCardPaymentModal = () => {
    setIsCardPaymentModalOpen(true)
  }

  const editPaymentMethodDropdown = (
    <DropdownMenu
      align='end'
      trigger={() => (
        <IconButton icon={PenSquareIcon} label='Edit payment method' />
      )}
    >
      <DropdownMenu.Item
        leftIcon={PenSquareIcon}
        onSelect={showCardPaymentModal}
      >
        Edit
      </DropdownMenu.Item>
      <DropdownMenu.Item
        leftIcon={Trash2Icon}
        onSelect={onRemovePaymentMethod}
        type='destructive'
      >
        Remove
      </DropdownMenu.Item>
    </DropdownMenu>
  )

  return (
    <div className='flex flex-row items-center justify-between gap-2'>
      <div className='flex flex-col gap-1 flex-1'>
        <span className='body-bold'>Payment details</span>
        {!cardDetails && (
          <span className='body-sm text-gray-500'>
            Please add a valid card to complete your purchase.
          </span>
        )}
        {cardDetails && (
          <div className='flex flex-row items-center justify-between gap-2'>
            <CardPaymentDetails brand={cardDetails.brand} last4={cardDetails.last4} />
            {!readonly && editPaymentMethodDropdown}
          </div>
        )}
      </div>
      {!cardDetails && !readonly && (
        <div className='-mr-4'>
          <Button
            variant='tertiary'
            onClick={showCardPaymentModal}
          >
            Add card
          </Button>
        </div>
      )}
      <CardPaymentModal
        open={isCardPaymentModalOpen}
        onOpenChange={setIsCardPaymentModalOpen}
      />
    </div>
  )
}
